import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Container = styled.div`
  position: relative;
  width: 100%;
  height: ${(props) => props.height}px;
  background-color: ${(props) => props.backgroundColor};
  margin: auto;
  border-top-left-radius: ${(props) => props.radiusTop}px;
  border-top-right-radius: ${(props) => props.radiusTop}px;
  border-bottom-right-radius: ${(props) => props.radiusBottom}px;
  border-bottom-right-radius: ${(props) => props.radiusBottom}px;
`;

const Load = styled.div`
  position: absolute;
  display: inline-block;
  height: 100%;
  background-color: ${(props) => props.loadedColor};
  width: ${(props) => props.loadedSteps}%;
  margin: auto;
  border-top-left-radius: ${(props) => props.radiusTop}px;
  border-bottom-left-radius: ${(props) => props.radiusBottom}px;
`;

const loadPercent = (percent) => {
  if (percent > 100) return 100;
  if (percent < 0) return 0;
  return percent;
};

const Stepper = (props) => {
  const { loadedSteps, totalSteps, backgroundColor, loadedColor, height, radiusTop, radiusBottom } = props;

  const percent = (loadedSteps / totalSteps) * 100;

  return (
    <Container
      {...props}
      backgroundColor={backgroundColor}
      height={height}
      radiusTop={radiusTop}
      radiusBottom={radiusBottom}
    >
      <Load
        loadedSteps={loadPercent(percent)}
        loadedColor={loadedColor}
        radiusTop={radiusTop}
        radiusBottom={radiusBottom}
      />
    </Container>
  );
};

Stepper.defaultProps = {
  loadedSteps: 0,
  totalSteps: 2,
  backgroundColor: 'lightgrey',
  loadedColor: 'blue',
  height: 3,
  radiusTop: 0,
  radiusBottom: 0,
};

Stepper.propTypes = {
  loadedSteps: PropTypes.number,
  totalSteps: PropTypes.number,
  backgroundColor: PropTypes.string,
  loadedColor: PropTypes.string,
  height: PropTypes.number,
  radiusTop: PropTypes.number,
  radiusBottom: PropTypes.number,
};

export default Stepper;

